// extracted by mini-css-extract-plugin
export var container = "_2w-0";